
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { MaterialPrefix } from "@/types/slab";
import { PriceCategory } from "@/types/priceCategory";

interface ProductMainFieldsProps {
  formData: {
    code: string;
    name: string;
    type: string;
    price: number;
    location_id: string;
    price_group_id: string;
  };
  materialPrefixes?: MaterialPrefix[];
  priceGroups?: PriceCategory[];
  locations?: any[];
  onFieldChange: (field: string, value: string | number) => void;
}

export function ProductMainFields({ 
  formData, 
  materialPrefixes, 
  priceGroups, 
  locations,
  onFieldChange 
}: ProductMainFieldsProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div className="space-y-2">
        <Label htmlFor="code">Código (Automático)</Label>
        <Input id="code" value={formData.code} readOnly disabled className="bg-muted" />
      </div>

      <div className="space-y-2">
        <Label htmlFor="name">Nome</Label>
        <Input 
          id="name" 
          value={formData.name} 
          onChange={e => onFieldChange('name', e.target.value)}
          required 
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="type">Material</Label>
        <Select 
          value={formData.type} 
          onValueChange={value => onFieldChange('type', value)}
        >
          <SelectTrigger>
            <SelectValue placeholder="Selecione o material" />
          </SelectTrigger>
          <SelectContent>
            {materialPrefixes?.map(material => (
              <SelectItem key={material.id} value={material.material_type}>
                {material.material_type}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-2">
        <Label htmlFor="price_group">Grupo de Preço</Label>
        <Select 
          value={formData.price_group_id} 
          onValueChange={value => onFieldChange('price_group_id', value)}
        >
          <SelectTrigger>
            <SelectValue placeholder="Selecione o grupo de preço" />
          </SelectTrigger>
          <SelectContent>
            {priceGroups?.map(group => (
              <SelectItem key={group.id} value={group.id}>
                {group.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-2">
        <Label htmlFor="location">Localização</Label>
        <Select 
          value={formData.location_id} 
          onValueChange={value => onFieldChange('location_id', value)}
        >
          <SelectTrigger>
            <SelectValue placeholder="Selecione a localização" />
          </SelectTrigger>
          <SelectContent>
            {locations?.map(location => (
              <SelectItem key={location.id} value={location.id}>
                {location.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-2">
        <Label htmlFor="price">Preço</Label>
        <Input 
          id="price" 
          type="number" 
          value={formData.price} 
          onChange={e => onFieldChange('price', Number(e.target.value))}
          min="0"
          step="0.01"
          required 
        />
      </div>
    </div>
  );
}
